export default __webpack_public_path__ + "static/media/demo_2.57773d8b.png";